import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GuidanceService } from 'src/app/admin/services/guidance/guidance.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
  selector: 'app-list-guidance-card',
  templateUrl: './list-guidance-card.component.html',
  styleUrls: ['./list-guidance-card.component.scss'],
  standalone: false
})
export class ListGuidanceCardComponent implements OnInit {


  BaseUrl = ''
  constructor(
    private guidanceService: GuidanceService,
    private spinner: NgxSpinnerService,
    private userdata: UserdataService,
    private toast: ToastrService,
    private trusturl: DomSanitizer,
    @Inject('BASE_IMAGE_URL') _imageurl: any
  ) {
    this.BaseUrl = _imageurl
  }
  title = 'angular-datatables';

  dataList = [];
  id: any = '';
  temp: any = [];
  ColumnMode = ColumnMode;
  token: any = [];

  @ViewChild(DatatableComponent) myFilterTable: DatatableComponent | any;

  ngOnInit() {
    this.getCardsList()
  }

  /* ***********
  list Blog
  *********** */

  getCardsList() {
    this.spinner.show()
    this.guidanceService.getGuidanceCards({ "isDelete": false }).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.dataList = res.data;
        this.temp = this.dataList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  /**
 * Update filter
 */
  updateFilter(event: any) {
    const val = event.target.value.toLowerCase();

    const temp = this.temp.filter((d: any) => {
      const name = d.name?.toLowerCase() || '';
      const autoId = d.autoId?.toString() || '';

      return name.includes(val) || autoId.includes(val);
    });

    this.dataList = temp;
    this.myFilterTable.offset = 0;
  }

  getSanitizeUrl(url: string) {
    return this.trusturl.bypassSecurityTrustUrl(this.BaseUrl + url)
  }

}
